var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38768 15.5H2.56061L3.38768 9.66667H0.49292C0.0132168 9.66667 0.0214874 9.4 0.178632 9.11667C0.335776 8.83333 0.219985 9.05 0.236527 9.01667C1.30345 7.11667 2.90798 4.28333 5.04183 0.5H5.8689L5.04183 6.33333H7.93659C8.34186 6.33333 8.39975 6.60833 8.32531 6.75833L8.26742 6.88333C5.00875 12.625 3.38768 15.5 3.38768 15.5Z",
    fill: "#FDA536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 3.5V12.5",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.353 8L11.353 8",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.396 4.025L36.4043 4.01667L33.3275 0.916667L32.4508 1.8L34.196 3.55833C33.4185 3.85833 32.8644 4.60833 32.8644 5.5C32.8644 6.65 33.7907 7.58333 34.9321 7.58333C35.2298 7.58333 35.5028 7.51667 35.7591 7.40833V13.4167C35.7591 13.875 35.387 14.25 34.9321 14.25C34.4772 14.25 34.105 13.875 34.105 13.4167V9.66667C34.105 8.75 33.3606 8 32.4508 8H31.6238V2.16667C31.6238 1.25 30.8794 0.5 29.9696 0.5H25.0072C24.0974 0.5 23.353 1.25 23.353 2.16667V15.5H31.6238V9.25H32.8644V13.4167C32.8644 14.5667 33.7907 15.5 34.9321 15.5C36.0734 15.5 36.9998 14.5667 36.9998 13.4167V5.5C36.9998 4.925 36.7682 4.4 36.396 4.025ZM29.9696 6.33333H25.0072V2.16667H29.9696V6.33333ZM34.9321 6.33333C34.4772 6.33333 34.105 5.95833 34.105 5.5C34.105 5.04167 34.4772 4.66667 34.9321 4.66667C35.387 4.66667 35.7591 5.04167 35.7591 5.5C35.7591 5.95833 35.387 6.33333 34.9321 6.33333Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhev);
export default __webpack_public_path__ + "static/media/PHEV.518f7ec4bde15436382f90e1b1376f9d.svg";
export { ForwardRef as ReactComponent };